export const splitInclusions = (inclusions, defaultDuration, newDuration) => {
  const extrasIndex = inclusions.search(/Optional Extras/i)

  // Trim content after "Optional Extras" or "optional extras"
  const trimmed =
    extrasIndex >= 0 ? inclusions.substring(0, extrasIndex) : inclusions

  const updatedDurations = trimmed
    .replace(
      new RegExp(`\\b${defaultDuration} breakfasts\\b`, "gi"),
      `${newDuration} breakfasts`,
    )
    .replace(
      new RegExp(`\\b${defaultDuration} nights\\b`, "gi"),
      `${newDuration} nights`,
    )

  const result = updatedDurations
    .replaceAll("h3", "h4")
    .replaceAll("<h4>", `<h4 class="green">`)
    .replace(
      `<h4 class="green">Not included</h4>`,
      `<h4 class="red">Not included</h4>`,
    )
    .replace(
      `<h4 class="green">Optional Extras</h4>`,
      `<h4 class="yellow">Optional Extras</h4>`,
    )
    .replace(
      `<h4 class="green">optional extras</h4>`,
      `<h4 class="yellow">optional extras</h4>`,
    )
    .replaceAll("<h2>", "<h3>")
    .replaceAll("</h2>", "</h3>")

  return result
}
